var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
import handleLoaderSize from './Loader.helpers';
const circleAnimation = keyframes `
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;
const LoaderBase = styled.div `
  ${({ loaderSize }) => handleLoaderSize(loaderSize)}
  transform-origin: center center;
  border-style: solid;
  border-color: ${({ color }) => color || 'currentColor'};
  border-right-color: transparent;
  border-radius: 50%;
  animation: ${circleAnimation} 1s infinite linear;
  position: relative;
  ${({ customCss }) => customCss || ''};

  &::before {
    content: '';
    ${({ loaderSize }) => handleLoaderSize(loaderSize, true)};
    border-style: solid;
    border-color: transparent;
    border-right-color: ${({ color }) => color || 'currentColor'};
    opacity: 0.2;
    position: absolute;
    border-radius: 50%;
  }
`;
const Loader = (_a) => {
    var { loaderSize, customCss } = _a, delegated = __rest(_a, ["loaderSize", "customCss"]);
    return (_jsx(LoaderBase, Object.assign({ customCss: customCss, loaderSize: loaderSize }, delegated), void 0));
};
export default Loader;
//# sourceMappingURL=Loader.js.map